import * as React from 'react';
import { Typography } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { useConsentStyles } from './styles';

const UNVERIFIED_HINT_ID = 'domain-unverified-hint';

// The domain is the client data the backend vouches for: plain text, never a
// link, never truncated (an ellipsis could hide the real host). `label` is
// optional (a connected app item has none). A client that is not CIMD
// declared its own domain, so `unverified` adds a textual badge and a visible
// hint below it; the hint describes the domain for assistive technology.
export default function DomainBadge({ label, domain, unverified = false }) {
  const { t } = useTranslation();
  const classes = useConsentStyles();

  return (
    <div>
      {label && (
        <Typography variant="caption" color="textSecondary" component="div">
          {label}
        </Typography>
      )}
      <div className={classes.domainBox}>
        <Typography
          variant="subtitle1"
          component="p"
          className={classes.domain}
          aria-describedby={unverified ? UNVERIFIED_HINT_ID : undefined}
        >
          {domain}
        </Typography>
        {unverified && (
          <React.Fragment>
            <Typography variant="caption" component="p">
              <span className={classes.badge}>{t('mcp.consent.unverifiedBadge')}</span>
            </Typography>
            {/* text.primary: text.secondary on the tinted box is below 4.5:1 */}
            <Typography id={UNVERIFIED_HINT_ID} variant="caption" component="p" className={classes.unverifiedHint}>
              {t('mcp.consent.unverifiedHint')}
            </Typography>
          </React.Fragment>
        )}
      </div>
    </div>
  );
}
